import qs from 'qs'

export default {
    namespaced: true,
    state: {
        popup_delivery_open: false,
        popup_payment_methods_open: false,
    },
    mutations: {
        popup_delivery_visibility(state, status) {
            state.popup_delivery_open = status;
        },
        popup_payment_methods_visibility(state, status) {
            state.popup_payment_methods_open = status;
        }
    },
    getters: {
        popup_delivery_is_open: (state) => state.popup_delivery_open,
        popup_payment_methods_is_open: (state) => state.popup_payment_methods_open
    }
};